// 功能开关 · 上线聚焦期(与 web 同策略)
//
// 主路径焊死期,管理后台只保留运维主路径必需的:大盘 / 用户 / 任务 / 审计 / 配置。
// 其余子系统用开关隐藏(代码保留,不删),改回 true 即恢复。
//
// payment —— 订单列表。【常开】不管走哪家渠道都得能查单、看状态、人工到账。
// transferPay —— 【支付渠道】人工扫码转账那一套的配套后台:入账对账 / 孤儿单认领。
//   2026-07-29 关闭:改接专门支付渠道,没有转账就没有"银行流水对不上订单"这个问题,
//   这两页失去对账对象。与 web 的 FEATURES.transferPay 同进同退。
// billingConfig —— 充值套餐 / 订阅档位。商品定义,与渠道无关,常开。
//   (注册赠送积分曾放在订阅档位页,已移到「系统配置」——它是面向所有新用户的赠送
//    规则,不是卖给付费用户的商品。)
// contentOps —— 预设 / 规范 / 手册 / 候选(内容运营 + RAG 子系统),聚焦期冻结。
// 测试期放开(后端路由均已就绪);正式上线前按需回滚。
export const FEATURES = {
  payment: true,
  transferPay: false,
  billingConfig: true,
  contentOps: true,
  // 收款码池(手动扫码额度管理):2026-07-16 需求隐藏;恢复改 true(大盘渠道表+配置页码池卡)
  qrPool: false,
  // 内容预设(首页 chip 字典):前端未消费,2026-07-16 隐藏
  presets: false,
} as const
